import {endpointsApi} from "./endpoint-api";

const url_api = 'https://lmap-dev.central-ws.com/api/';

export const environment = {
  production: false,
  urlApi: url_api,
  googleAnalyticsId: 'G-E0KNNESMCC',
  ...endpointsApi(url_api)
};
